export default __webpack_public_path__ + "static/media/events_menu_item.903de076.svg";